<div class="julia-block julia-record">
  <div class="block-toolbar">
    <a *ngIf="link as href" class="record-open" [href]="href" (click)="open($event, href)">
      {{ 'julia.blocks.open' | translate }}
    </a>
    <button class="block-btn" (click)="download()" [disabled]="exporting">
      {{ (exporting ? 'julia.blocks.exporting' : 'julia.blocks.export') | translate }}
    </button>
  </div>

  <div class="block-error" *ngIf="error">{{ error | translate }}</div>

  <dl class="record-fields" *ngIf="page">
    <ng-container *ngFor="let field of fields">
      <dt>{{ field.title }}</dt>
      <dd>{{ field.value }}</dd>
    </ng-container>
  </dl>

  <div class="record-lists" *ngIf="children.length">
    <div class="record-tabs">
      <button *ngFor="let child of children" class="record-tab" [class.active]="tab?.name === child.name"
              (click)="select(child)">
        {{ child.title || child.name }} <span class="tab-count">{{ child.total }}</span>
      </button>
    </div>
    <ng-container *ngFor="let child of children">
      <app-julia-table-block *ngIf="tab?.name === child.name"
                             [block]="block" [sessionId]="sessionId" [child]="child"
                             (expired)="expired.emit()">
      </app-julia-table-block>
    </ng-container>
  </div>
</div>
